import React from 'react';
import { BarChart2Icon, TrendingUpIcon, GridIcon } from 'lucide-react';
export function BusinessAreas() {
  return <section id="business" className="w-full bg-gray-50 py-16 md:py-24" data-id="element-35">
      <div className="container mx-auto px-4" data-id="element-36">
        <div className="text-center mb-16" data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-38">
            业务范围
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-39">
            我们提供全方位的量化交易服务，满足不同客户的投资需求
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-40">
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-41">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-42">
              <BarChart2Icon size={32} className="text-blue-700" data-id="element-43" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-44">量化交易</h3>
            <p className="text-gray-600 mb-6" data-id="element-45">
              运用数学模型和统计方法，通过大数据分析寻找市场机会，实现自动化交易决策。我们的量化策略经过严格回测，表现出色且稳定。
            </p>
            <ul className="space-y-2 text-gray-600" data-id="element-46">
              <li className="flex items-center" data-id="element-47">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-48"></span>
                统计套利策略
              </li>
              <li className="flex items-center" data-id="element-49">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-50"></span>
                多因子选股模型
              </li>
              <li className="flex items-center" data-id="element-51">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-52"></span>
                机器学习预测
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-53">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-54">
              <TrendingUpIcon size={32} className="text-blue-700" data-id="element-55" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-56">高频交易</h3>
            <p className="text-gray-600 mb-6" data-id="element-57">
              利用先进的技术基础设施和极低延迟的执行系统，捕捉市场微观结构中的短期价格波动，实现毫秒级别的交易执行。
            </p>
            <ul className="space-y-2 text-gray-600" data-id="element-58">
              <li className="flex items-center" data-id="element-59">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-60"></span>
                市场微结构分析
              </li>
              <li className="flex items-center" data-id="element-61">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-62"></span>
                超低延迟交易系统
              </li>
              <li className="flex items-center" data-id="element-63">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-64"></span>
                做市商策略
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-65">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-66">
              <GridIcon size={32} className="text-blue-700" data-id="element-67" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-68">合约网格</h3>
            <p className="text-gray-600 mb-6" data-id="element-69">
              基于价格区间波动特性，自动在不同价格点位设置买卖单，通过高频小幅波动获利。适合震荡市场环境，降低情绪化交易风险。
            </p>
            <ul className="space-y-2 text-gray-600" data-id="element-70">
              <li className="flex items-center" data-id="element-71">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-72"></span>
                智能网格策略
              </li>
              <li className="flex items-center" data-id="element-73">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-74"></span>
                动态调整机制
              </li>
              <li className="flex items-center" data-id="element-75">
                <span className="w-2 h-2 bg-blue-700 rounded-full mr-2" data-id="element-76"></span>
                风险对冲系统
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}